<div class="white-board">
  <div *ngIf="isLogo" class="white-board-logo">
    <img draggable="false" src="/assets/img/logo.svg" alt="intilio" />
  </div>

  <div class="white-board-content" *ngIf="template">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
</div>
